import React, { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import messages from '../../messages';
import { InventoryImport } from './inventory-import';
import { InventoryContext } from '../inventory-context';

export const ImportButton = () => {
  const { refreshGridData, refreshWarehouseLocations } = useContext(InventoryContext);

  const onImportFinish = useCallback(() => {
    refreshGridData();
    refreshWarehouseLocations();
  }, [refreshGridData, refreshWarehouseLocations]);

  return (
    <InventoryImport
      onImportFinish={onImportFinish}
      renderOpener={(open) => {
        return (
          <Button className={style['reusable-button']} onClick={open} theme='tertiary'>
            <FormattedMessage {...messages.importButton} />
          </Button>
        );
      }}
    />
  );
};
